import { createSlice } from '@reduxjs/toolkit';

import type { MyUser } from './types';

export const slice = createSlice({
    initialState: {
        myUser: null as MyUser
    },

    name: 'useAccount',

    reducers: {
        myUser: (state, action) => {
            state.myUser = action.payload;
        }
    }
});

export default slice.reducer;
